import { TestCase, TestSuite } from './TestResults.types';

// The name of the property a test report carries the test framework's own identifier of a test case in.
const TEST_CASE_IDENTIFIER_PROPERTY = 'test-identifier';

export function decorateWithIds(suites?: TestSuite[]): TestSuite[] | undefined {
  return suites?.map((suite) => {
    return {
      ...suite,
      id: crypto.randomUUID(),
      testSuites: decorateWithIds(suite.testSuites),
      testCases: suite.testCases?.map((testCase) => ({ ...testCase, id: crypto.randomUUID() })),
    };
  });
}

export function testCaseIdentifierOf(testCase: TestCase): string | undefined {
  return testCase.properties?.find(({ key }) => key === TEST_CASE_IDENTIFIER_PROPERTY)?.value;
}
